var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68.26 57.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-name": "Layer 71"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.33,
    cy: 12.56,
    r: 2.75,
    fill: "none",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 3,
    d: "M56.76 34.35 35 56.14 5.64 27.66 1.55 5.08a3 3 0 0 1 3.57-3.52l22.31 4.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 3,
    d: "m40.33 51.62 4.65 4.52 21.78-21.79L37.43 5.88 15.12 1.56l-1.53 1.46"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "m31.75 38.19-.18-1c-.05-.28.05-.52.34-.55a6.6 6.6 0 0 0 2.93-1c-1.11-1.1-2.17-2.2-3.27-3.3-2 .89-4 1.44-5.72-.07a4.3 4.3 0 0 1-.51-.54c-.93-1.14-1.28-3.17.39-5.23l-.46-.46a.38.38 0 0 1 0-.55l.14-.15a.39.39 0 0 1 .55 0l.48.48a7.4 7.4 0 0 1 3.19-1.53.51.51 0 0 1 .58.41c.12.64.41 1.46-.17 1.57a8.8 8.8 0 0 0-2.29.86l3.19 3.22c2.15-.88 4.38-1.5 6.12.24 1.52 1.52 1.4 3.82-.21 5.69l1.51 1.51a.39.39 0 0 1 0 .57c-.16.16-.43.34-.64.12L36.16 37a6.67 6.67 0 0 1-3.87 1.6c-.23-.01-.45 0-.54-.41M27 27.83a2 2 0 0 0-.13 2.67c.74.74 1.73.74 3.07.27zm8.66 4.44c-.7-.7-1.69-.73-3.1-.27l3 3a2.09 2.09 0 0 0 .11-2.73z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrice);
export default __webpack_public_path__ + "static/media/price.55001e2547caacc11c761b802624985a.svg";
export { ForwardRef as ReactComponent };